export function Footer() {
  return (
    <footer class="footer">
      Copyright © {new Date().getFullYear()} yum.recipes. All rights reserved.
    </footer>
  );
}
